import * as Common from "../../commons/common"

export class SheetListCondition{
  sheet_id: string = ""
  sheet_code: string = ""
  event_code: string = ""
  nendo: string = ""
  month: string = ""
  curriculum_id: string = ""
  grade: string = ""
  room_code: string = ""
  capture_date: string = ""
  pending_exists: string = ""
  saiten_flg: string = ""
  is_aggregated: string = ""
  level: string = ""
  times: string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}

export class Sheet{
  id: number
  sheet_code: string
  nendo: number
  month: number
  sheet_name: string
  curriculum_id: number
  grade: number
  level: string
  times: number
  room_name: string
  class_name: string
  student_count: number
  capture_date: string
  aggregated_at: string
  aggregated_user_name: string
  score_positions_completed: boolean
  pending_exists: boolean
  uploaded_count: number
  image_completed_count: number
  score_average: number
  progress_rate: number
  cut_job_count: number
  full_count: number

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_code = sheet.sheet_code;
    this.nendo = sheet.nendo;
    this.month = sheet.month;
    this.sheet_name = sheet.sheet_name;
    this.curriculum_id = sheet.curriculum_id;
    this.grade = sheet.grade;
    this.level = sheet.level;
    this.times = sheet.times;
    this.room_name = sheet.room_name;
    this.class_name = sheet.class_name;
    this.student_count = sheet.student_count;
    this.capture_date = sheet.capture_date;
    this.aggregated_at = sheet.aggregated_at;
    this.aggregated_user_name = sheet.aggregated_user_name;
    this.score_positions_completed = sheet.score_positions_completed;
    this.pending_exists = sheet.pending_exists;
    this.uploaded_count = sheet.uploaded_count;
    this.image_completed_count = sheet.image_completed_count;
    this.score_average = sheet.score_average;
    this.progress_rate = sheet.progress_rate;
    this.cut_job_count = sheet.cut_job_count;
    this.full_count = sheet.full_count;
  }
}